import { Form, Input } from "antd";
import { useForm } from "antd/lib/form/Form";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../../components/DraggableModal";
import { EntTypesOfProduct } from "../../../../../models/handBooks/typeofproduct";
import SelectProductCategory from "../../../../../components/selects/SelectProductCategory";

interface IProps {
  show: boolean;
  productCategory: EntTypesOfProduct;
  onHide: () => void;
  onSubmit: (pos: EntTypesOfProduct) => Promise<boolean>;
}

enum FormField {
  nameKy = 'nameKy',
  nameRu = 'nameRu'
}

export const AddTypesOfProductCategory = (props: IProps) => {
  const { t } = useTranslation();
  const [form] = useForm();
  const [loading, setLoading] = useState<boolean>(false);
  const [subcategories, setSubcategories] = useState<Array<{ nameRu: string; nameKy: string }>>([]);

  useEffect(() => {
    if (props.show) {
      form.setFields([
        { name: FormField.nameKy, value: props.productCategory.nameKy },
        { name: FormField.nameRu, value: props.productCategory.nameRu }
      ]);
      setSubcategories(props.productCategory.children || []);
    }
  }, [props.show, props.productCategory]);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      
      const data: EntTypesOfProduct = {
        ...props.productCategory,
        nameKy: values.nameKy,
        nameRu: values.nameRu,
        children: subcategories
      };

      console.log('Отправляемые данные:', {
        nameRu: data.nameRu,
        nameKy: data.nameKy,
        children: data.children
      });

      const result = await props.onSubmit(data);
      if (result) {
        props.onHide();
        setSubcategories([]);
        form.resetFields();
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSubcategoryAdd = (newSubcategories: Array<{ nameRu: string; nameKy: string }>) => {
    setSubcategories(newSubcategories);
  };

  return (
    <>
      <DraggableModal
        title={props.productCategory.id === null ? t('handbooks.types_of_products.Add Product Type') : t('handbooks.types_of_products.Edit Product Type')}
        visible={props.show}
        onCancel={() => {
          props.onHide();
          setSubcategories([]);
          form.resetFields();
        }}
        onSubmit={handleSubmit}
        submitLoading={loading}
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{ remember: true }}
          autoComplete="off"
        >
          <Form.Item
            label={t('general.nameKy')}
            name={FormField.nameKy}
            rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
          >
            <Input autoComplete="off" />
          </Form.Item>
          <Form.Item
            label={t('general.nameRu')}
            name={FormField.nameRu}
            rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
          >
            <Input autoComplete="off" />
          </Form.Item>

          <SelectProductCategory 
            onChange={handleSubcategoryAdd} 
            value={subcategories}
          />
        </Form>
      </DraggableModal>
    </>
  );
};